// extracted by mini-css-extract-plugin
export default {"container":"styles_container__Fnkii","title":"styles_title__IlgFE","buttons":"styles_buttons__zEWJI","button":"styles_button__sSQ31"};